// Ant Design theme configuration and design tokens

export const theme = {
  token: {
    colorPrimary: '#a1e430',
    borderRadius: 30,
    colorBgContainer: '#1a1a1a',
    colorText: '#ffffff',
    colorTextSecondary: '#b0b0b0',
  },
  components: {
    Button: {
      colorPrimary: '#a1e430',
      colorPrimaryHover: '#b5f044',
      colorPrimaryActive: '#8bc72a',
      primaryColor: '#2d3b2d',
      borderRadius: 30,
    },
    Select: {
      colorBgContainer: '#2a2a2a',
      colorBorder: '#404040',
      colorText: '#ffffff',
      borderRadius: 8,
      optionSelectedBg: '#3a3a3a',
    },
  },
};

// Design tokens for consistent styling
export const designTokens = {
  colors: {
    primary: '#a1e430',
    primaryText: '#2d3b2d',
    background: '#1a1a1a',
    surface: '#2a2a2a',
    border: '#404040',
    text: '#ffffff',
    textSecondary: '#b0b0b0',

    // Zone colors
    zoneDefault: '#d3d3d3',
    zoneBorderDefault: '#808080',

    // Color scale for trips (yellow to red)
    scaleMin: '#ffff00', // Yellow - 0%
    scaleMax: '#ff0000', // Red - 100%
  },

  borderRadius: {
    button: 30,
    card: 8,
    input: 8,
  },

  zIndex: {
    controls: 1000,
    tooltip: 1100,
    modal: 1200,
  },
};

export default theme;
